import styled from 'styled-components';

export const StyledMyCardContainer = styled.div`
  background-color: #fff;
  padding: 60px;
  border-radius: 30px;
  box-shadow: 0px 16px 24px -6px rgba(27, 36, 44, 0.16);

`